export const INCOMPLETE = 'incomplete_information';
export const PENDING = 'pending';
export const ACCEPTED = 'accepted';
export const DECLINED = 'declined';
export const ACTIVE = 'active';
export const SUSPENDED = 'suspended';
export const ENDED = 'ended';
